import { render, staticRenderFns } from "./CauHinh.vue?vue&type=template&id=6a48bbe9&scoped=true"
import script from "./CauHinh.vue?vue&type=script&lang=js"
export * from "./CauHinh.vue?vue&type=script&lang=js"
import style0 from "./CauHinh.vue?vue&type=style&index=0&id=6a48bbe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a48bbe9",
  null
  
)

export default component.exports